/**
 * Tagada Rx — docs entry points on the CRM landing.
 *
 * The public docs live at docs.tagada.io (Mintlify). This is the merchant-
 * facing pointer so the overview is not a dead end.
 */

import { ArrowUpRight, BookOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { brandingConfig } from '@/config/branding';

const RX_DOCS_PATH = '/developer-tools/rx/introduction';

export function rxDocsUrl(): string {
  const base = (brandingConfig.docsUrl || 'https://docs.tagada.io').replace(/\/$/, '');
  return `${base}${RX_DOCS_PATH}`;
}

export function RxDocsButton() {
  const { t } = useTranslation('rx');
  return (
    <Button variant="outline" size="sm" asChild>
      <a href={rxDocsUrl()} target="_blank" rel="noreferrer">
        <BookOpen className="h-4 w-4" />
        {t('docsCard.button')}
      </a>
    </Button>
  );
}

export function RxDocsCard() {
  const { t } = useTranslation('rx');
  return (
    <a
      href={rxDocsUrl()}
      target="_blank"
      rel="noreferrer"
      className="group border-primary/20 bg-primary/5 hover:border-primary/40 hover:bg-primary/10 flex items-start gap-4 rounded-xl border p-4 transition-colors"
    >
      <div className="bg-primary/10 text-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-lg">
        <BookOpen className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="flex items-center gap-1.5 text-sm font-semibold">
          {t('docsCard.cardTitle')}
          <ArrowUpRight className="text-muted-foreground group-hover:text-primary h-3.5 w-3.5 transition-colors" />
        </p>
        <p className="text-muted-foreground mt-1 text-sm leading-relaxed">
          {t('docsCard.cardBody')}
        </p>
      </div>
    </a>
  );
}
